export default {
  routes: {
    routes: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      pages: 0,
      prev: null,
      next: null
    }
  },
  route : null,
  stations : {
    stations: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      pages: 0,
      prev: null,
      next: null
    }
  },
  zone_id : null,
  currentPage : 1,
  stationPage : 1,
}
